import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { LanguageService } from '@core/services/language/language.service';
import { Languages } from '@enums/languages';
import { LnHeroComponent } from '@components/ln-hero/ln-hero.component';
import { LnPagesArmorComponent } from '@components/ln-pages-armor/ln-pages-armor.component';
import { LnSpecialProductsComponent } from '@components/ln-special-products/ln-special-products.component';
import { ArtisansDesignersCreatedProductsComponent } from '@components/artisans-designers-created-products/artisans-designers-created-products.component';
import { SearchBarValue } from '@core/services/search-bar-value/search-bar-value';

@Component({
  selector: 'ln-home',
  imports: [
    LnHeroComponent,
    LnPagesArmorComponent,
    LnSpecialProductsComponent,
    ArtisansDesignersCreatedProductsComponent,
  ],
  templateUrl: './ln-home.component.html',
  styleUrl: './ln-home.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LnHomeComponent {
  // private TAG = 'LnHomeComponent';
  searchBarValue = inject(SearchBarValue);
  language = inject(LanguageService);
  Languages = Languages;
  activeLanguage = this.language.activeLanguage;

  constructor() {
    this.clearSearchBarValue();
  }

  clearSearchBarValue(): void {
    this.searchBarValue.setSearchBarValue('');
  }
}
